import SideNav from "../components/sideNav"
import TopNav from "../components/topNav"
import AppContent from "./AppContent"
import { Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
// import UseSSE from './CardReader'
import AvailableUserModal from "../pages/users/AvailableUserModal"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DefaultLayout = () => {
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState<any>(null)
  const [availableUserModal, setAvailableUserModal] = useState(false)
  const [details, setDetails] = useState<any>({})

  // const [sseData, setSseData] = useState(null);
  // const useSSE = UseSSE({ userId: 'aberto20', onMessage: (data) => setSseData(data) });

  // console.log("SSE Hook:", sseData);

  // useEffect(() => {
  //   if (sseData) {
  //     //@ts-ignore
  //     const response = JSON.parse(sseData);
  //     setDetails(response.payload?.[0]);
  //     setAvailableUserModal(true);
  //   }
  // }, [sseData]);

  useEffect(() => {
    setToken(sessionStorage.getItem('isLoggedIn'));
    setLoading(false);
  }, []);

  if (loading) {
    return <>loading....</>
  }

  if (!token) {
    return <Navigate to='/login' />
  }
  return (
    <div className="root-container">
      <div className="root-container__side-nav">
        <SideNav />
      </div>
      <div className="root-container__body">
        <div className="top-nav">
          <TopNav />
        </div>
        <div className="content">
          <AppContent />
        </div>
      </div>
      {availableUserModal && <AvailableUserModal
        show={availableUserModal}
        hide={() => setAvailableUserModal(false)}
        details={details}
        handleDetails={() => window.location.href = `/users/details/${details.id}`}
      />}
      <ToastContainer />
    </div>
  )
}
export default DefaultLayout